var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "24 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "default no-stroke",
    transform: "translate(23.93 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1C2.1 1 1 2.1 1 3.5v11C1 15.9 2.1 17 3.5 17h17c1.4 0 2.5-1.1 2.5-2.5v-11C23 2.1 21.9 1 20.5 1h-17zm17 17h-17C1.6 18 0 16.4 0 14.5v-11C0 1.6 1.6 0 3.5 0h17C22.4 0 24 1.6 24 3.5v11c0 1.9-1.6 3.5-3.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.7v4.5l3.9-2.3-3.9-2.2zM9.6 13V5l7 4-7 4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6 16l-.1-8 7 4-6.9 4zM44.5 3h-17C25.6 3 24 4.6 24 6.5v11c0 1.9 1.6 3.5 3.5 3.5h17c1.9 0 3.5-1.6 3.5-3.5v-11C48 4.6 46.4 3 44.5 3z"
  }))));
}
SvgYoutube.displayName = 'Youtube';
export default SvgYoutube;